import { capitalizeFirstLetter } from "../utils/Helper";

const ValidationMessage = {
    Field: (name: any) => `Please enter ${name}.`,
    SelectField: (name: any) => `Please select ${name}.`,
    MinLength: (name: string, length: number) => `${capitalizeFirstLetter(name)} must be at least ${length} characters.`,
    MONTHLY_INCOME: (name: string, length: number) => `${capitalizeFirstLetter(name)} cannot exceed more than ${length} digits.`,
    MaxLength: (name: string, length: number) => `${capitalizeFirstLetter(name)} cannot exceed more than ${length} characters.`,
    OnlyAlphabets: (name: string) => `Your ${(name)} should contain only letters and spaces.`,


    Password_Message: (name: any) => `Please enter your ${name}.`,
    PHONE_NUMBER_REGEX: /^[0-9]{10,15}$/,
    RE_ENTER_PASSWORD: 'Please re-enter your new password.',


    EMAIL_ADDRESS: 'Please enter a valid email address.',
    EMAIL_REGREX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/,
    // EMAIL_REGREX: /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/,
    ANY_REQUIRED: 'Please enter your ',
    ANY_SELECT: 'Please select your ',

    PHONE_REQUIRED: "Please enter your phone number.",
    PHONE_NUMBER_MAX: "Phone number must be only 10 digit.",
    PHONE_MIN_CHAR: "Phone number must have at least 7 digits.",
    PHONE_MAX_CHAR: "Phone number must be at most 15 digits.",
    // VALID_PHONE_NUMBER: "Please enter valid phone number",
    VALID_PHONE_NUMBER: "Phone number must be at last 7 numbers.",
    VALID_PHONE: "Please enter valid phone number.",


    OLD_PASSWORD_REQUIRED: "Please enter your old password.",
    OLD_PASSWORD_MIN_CHAR: "Old password must have 8-15 characters.",
    OLD_PASSWORD_MAX_CHAR: "Old password must have 8-15 characters.",

    PASSWORD_REQUIRED: "Please enter your password.",
    NEW_PASSWORD_REQUIRED: "Please enter a new password.",
    PASSWORD_MIN_CHAR: "Your password must have 8-15 characters.",
    PASSWORD_MAX_CHAR: "Your password must have 8-15 characters.",

    PASSCODE_REQUIRED: "Please enter passcode.",
    CONFIRM_PASSWORD_REQUIRED: "Please re-enter your password.",
    CONFIRM_PASSWORD_MIN_CHAR: "Your password must have 8-15 characters.",
    CONFIRM_PASSWORD_MAX_CHAR: "Your password must have 8-15 characters.",
    CONFIRM_PASSWORD_VALID: "Password must have uppercase, lowercase, special character and number.",

    PASSWORD_CONFIRM_PASSWORD_MUST_MATCH: "Passwords do not match.",

    NO_SPACE_ALLOWED: "No space allowed.",
    PASSWORD_UPPER_CASE: "Your password must include an uppercase letter, a lowercase letter, and a digit.",
    // PASSWORD_UPPER_CASE: "Password must contain alphanumeric characters that includes atleast 1 uppercase, 1 lowercase and 1 special character.",
    PASSWORD_MATCH: "Password should be between 8 to 15 characters and should contain atleat one uppercase, one lowercase, one number and one special character.",
    CLAIMED_HOURS: "Please enter a number.",
    RATE: "Please enter a rate.",
    DESCRIPTION: "Please enter a description.",
}


export default ValidationMessage;
